export const vehicleStatusIds = {
    CHECK_IN: 2,
    CHECK_OUT: 21
};

export const searchByFieldTypes = {
    VIN: 'vin',
    ASSET_ID: 'assetId'
}